import IdentityClient from "./IdentityClient";
import { Constants } from "../../constants/constants";

const UserContactService = {

    async getDefaultUserContact() {
        const result = await IdentityClient().get(`${Constants.ApiPath.USER_CONTACT.GET_DEFAULT}`);
        return result.data.result;
    },

    async getAllUserContact() {
        const result = await IdentityClient().get(`${Constants.ApiPath.USER_CONTACT.GET_ALL_USER_CONTACT}`);
        return result.data.result;
    },

    async createContact(data: {
        addressId: string,
        phoneNumber: string,
        faxNumber: string,
        default: number
    }) {
        const result = await IdentityClient().post(Constants.ApiPath.USER_CONTACT.CREATE, data);
        return result.data;
    },

    async updateContact(data: {
        addressId: string,
        phoneNumber: string,
        faxNumber: string,
        default: number,
        id: string
    }) {
        const result = await IdentityClient().post(Constants.ApiPath.USER_CONTACT.UPDATE, data);
        return result.data;
    },

    async deleteContact(id: string) {
        const result = await IdentityClient().delete(`${Constants.ApiPath.USER_CONTACT.DELETE}/${id}`);
        return result.data;
    },
}

export default UserContactService